import type { SerializedStyles, Theme } from '@emotion/react';
import { css } from '@emotion/react';

import type { TextBackground } from './divider';

export const divider = (theme: Theme) => css`
  height: 1px;
  width: 100%;
  border: none;
  background: ${theme.palette.tertiary.mediumContrast};
  margin: 0;
`;

export const dividerText = (theme: Theme) => css`
  text-transform: uppercase;
  position: absolute;
  top: -50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 ${theme.spacing[16]};
  text-align: center;
`;

export const dividerTextBackground: Record<TextBackground, (theme: Theme) => SerializedStyles> = {
  primary: (theme) => css`
    background: ${theme.palette.background.main};
  `,
  secondary: (theme) => css`
    background: ${theme.palette.background.accent};
  `,
};

export const textVariant = css`
  position: relative;
`;
